import React from 'react';
import { CrossSellWidgetProvider } from '@cart-js/trip';
import { WrappedCrossSellConfig } from 'core/context/WrappedCartCrossSellConfig/WrappedCartCrossSellConfig';

const CrossSellWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
    return (
        <CrossSellWidgetProvider>
            <WrappedCrossSellConfig />
            {children}
        </CrossSellWidgetProvider>
    );
};
CrossSellWrapper.displayName = 'CrossSellWrapper';

export { CrossSellWrapper };
